/**
 * Custom hook untuk mengambil semua data ota channel color.
 * 
 * API Endpoint: GET `/api/v3/ota`
 * API Version: 3.0
 * 
 * @returns {object} - Semua data booking yang telah diformat
 * @example
 * const { data, isLoading, error } = useGetAllBooking();
 */

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { OtaResponseSchema } from "../response/IndexOtaChannel";

const API_VERSION = "v3";

export interface DateProp {
    gte: string;
    lte: string;
}

interface OtaFilterProps {
    property_id?: string;
}

interface IndexOtaChannel {
    page?: number,
    limit?: number,
    all?: boolean,
    filter?: OtaFilterProps,
}

const useIndexOtaChannel = (query: IndexOtaChannel) => {
    return useQuery({
        queryKey: [
            'ota',
            query.page,
            query.limit,
            query.filter?.property_id,
        ],
        queryFn: async () => {
            try {
                const params = {
                    ...(query.all ? { all: 1 } : { page: query.page ?? 1, limit: query.limit ?? 10 }),
                    ...(query.filter?.property_id ? { filter: { property_id: query.filter.property_id } } : {}),
                };

                const response = await privateApi.get(`/${API_VERSION}/ota`, { params });

                // Validasi response
                const validationResult = OtaResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid ota channel data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch ota channel`, error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useIndexOtaChannel;